<div
  class="shelf-container"
  [style]="shelfStyle$ | async"
  (mousemove)="onDragOver($event)"
  (mouseleave)="onDragLeave($event)"
>
  <div class="products-container" #shelfContainer [id]="shelfId">
    @if (emptyShelfText) {
    <div class="empty-shelf-text">{{ emptyShelfText }}</div>
    } @else { 
    
    @if (displayStacks.length > 0) {
      <!-- Handle stacks with placeholders between them -->
      @for (stack of displayStacks; track stackIndex; let stackIndex = $index) {
        <!-- Show placeholder BEFORE this stack -->
        <div
          *ngIf="placeholderService.shouldShowStackPlaceholder(dropIndex, shelfIndex, stackIndex)"
          class="stack placeholder-stack"
        >
          <app-planogram-manual-product
            *ngIf="(placeholderService.placeholder$ | async)?.product"
            [product]="(placeholderService.placeholder$ | async)!.product!"
            [dropIndex]="dropIndex"
            [shelfIndex]="shelfIndex"
            [stackIndex]="-1"
            [productIndex]="0">
          </app-planogram-manual-product>
        </div>

        <!-- The actual stack -->
        <app-planogram-manual-product-stack
          [stack]="stack"
          [dropIndex]="dropIndex"
          [shelfIndex]="shelfIndex"
          [stackIndex]="stackIndex"
        >
        </app-planogram-manual-product-stack>
      }
      
      <!-- Show placeholder AFTER the last stack -->
      <div
        *ngIf="placeholderService.shouldShowStackPlaceholder(dropIndex, shelfIndex, displayStacks.length)"
        class="stack placeholder-stack"
      >
        <app-planogram-manual-product
          *ngIf="(placeholderService.placeholder$ | async)?.product"
          [product]="(placeholderService.placeholder$ | async)!.product!"
          [dropIndex]="dropIndex"
          [shelfIndex]="shelfIndex"
          [stackIndex]="-1"
          [productIndex]="0">
        </app-planogram-manual-product>
      </div>
    } @else {
      <!-- Handle empty shelf case -->
      <div
        *ngIf="placeholderService.shouldShowStackPlaceholder(dropIndex, shelfIndex, 0)"
        class="stack placeholder-stack"
      >
        <app-planogram-manual-product
          *ngIf="(placeholderService.placeholder$ | async)?.product"
          [product]="(placeholderService.placeholder$ | async)!.product!"
          [dropIndex]="dropIndex"
          [shelfIndex]="shelfIndex"
          [stackIndex]="-1"
          [productIndex]="0">
        </app-planogram-manual-product>
      </div>
    }
    }
  </div>
  <div class="shelf-number">{{ shelfNumber }}</div>
</div>